import React, { useEffect, useState, useMemo } from "react";
import { Link } from "react-router-dom";
import withRouter from "components/Common/withRouter";
import TableContainer from "../../../components/Common/TableContainer";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  Badge,
  Button,
  UncontrolledTooltip,
} from "reactstrap";
import moment from "moment";

import Breadcrumbs from "components/Common/Breadcrumb";
import DeleteModal from "components/Common/DeleteModal";
import axios from "axios";
import toastr from "toastr";
import "toastr/build/toastr.min.css";

// --- API ---
const API_BASE = "https://dlaviapi.stechomeyazilim.info";
const LIST_URL = `${API_BASE}/Contact?$expand=Users&$orderby=Created_Datetime desc`;
const DEL_URL = (id) => `${API_BASE}/Contact(${id})`;

const showToast = (title, message, ok) => {
  toastr.options = { positionClass: "toast-top-right", timeOut: 3000 };
  ok ? toastr.success(message, title) : toastr.error(message, title);
};

const Messages = (props) => {
  document.title = "Gelen Mesajlar | DLApro";

  const [list, setList] = useState([]);
  const [viewModal, setViewModal] = useState(false);
  const [selected, setSelected] = useState(null);
  const [deleteModal, setDeleteModal] = useState(false);
  const [toDelete, setToDelete] = useState(null);

  useEffect(() => {
    fetchMessages();
  }, []);

  const fetchMessages = async () => {
    try {
      const res = await axios.get(LIST_URL);
      setList(res.data.value || []);
    } catch (e) {
      console.error("Mesajlar çekilemedi:", e);
      showToast("Hata", "Mesajlar çekilemedi", false);
    }
  };

  const handleView = (row) => {
    setSelected(row);
    setViewModal(true);
  };

  const handleDeleteClick = (row) => {
    setToDelete(row);
    setDeleteModal(true);
  };

  const onDeleteConfirm = async () => {
    if (toDelete && toDelete.ID) {
      try {
        await axios.delete(DEL_URL(toDelete.ID));
        showToast("Başarılı", "Mesaj silindi.", true);
        fetchMessages();
      } catch (e) {
        showToast("Hata", "Silme başarısız.", false);
      }
    }
    setDeleteModal(false);
  };

  const columns = useMemo(
    () => [
      { Header: "ID", accessor: "ID", Cell: ({ value }) => <span className="text-muted">#{value}</span> },
      {
        Header: "Gönderen",
        Cell: ({ row }) => {
          const u = row.original.Users;
          return (
            <div>
              <div className="fw-bold">{u?.Users_NameSurname || `Kullanıcı #${row.original.Users_ID || "-"}`}</div>
              <small className="text-muted">{u?.EMail || ""}</small>
            </div>
          );
        },
      },
      {
        Header: "Konu",
        accessor: "Subject",
        Cell: ({ value }) => <span className="fw-bold text-primary">{value || "-"}</span>,
      },
      {
        Header: "Tip",
        accessor: "Contact_Type",
        Cell: ({ value }) => <Badge color="info">{value || "Mesaj"}</Badge>,
      },
      {
        Header: "Mesaj",
        accessor: "Contents",
        Cell: ({ value }) => (value && value.length > 60 ? value.substring(0, 60) + "..." : value) || "-",
      },
      {
        Header: "Tarih",
        accessor: "Created_Datetime",
        Cell: ({ value }) => (value ? moment(value).format("DD.MM.YYYY HH:mm") : "-"),
      },
      {
        Header: "İşlemler",
        Cell: (cellProps) => (
          <div className="d-flex gap-3">
            <Link to="#" className="text-info" onClick={() => handleView(cellProps.row.original)}>
              <i className="mdi mdi-eye font-size-18" id="msgview" />
              <UncontrolledTooltip placement="top" target="msgview">Görüntüle</UncontrolledTooltip>
            </Link>
            <Link to="#" className="text-danger" onClick={() => handleDeleteClick(cellProps.row.original)}>
              <i className="mdi mdi-delete font-size-18" id="msgdel" />
              <UncontrolledTooltip placement="top" target="msgdel">Sil</UncontrolledTooltip>
            </Link>
          </div>
        ),
      },
    ],
    []
  );

  return (
    <React.Fragment>
      <DeleteModal show={deleteModal} onDeleteClick={onDeleteConfirm} onCloseClick={() => setDeleteModal(false)} />

      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Yönetim" breadcrumbItem="Gelen Mesajlar" />

          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <TableContainer
                    columns={columns}
                    data={list}
                    isGlobalFilter={true}
                    customPageSize={10}
                    className="custom-header-css"
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Modal isOpen={viewModal} toggle={() => setViewModal(false)} centered>
            <ModalHeader toggle={() => setViewModal(false)}>
              <i className="mdi mdi-email-outline me-2" />
              {selected?.Subject || "Mesaj"}
            </ModalHeader>
            <ModalBody>
              <p className="mb-1">
                <strong>Gönderen:</strong>{" "}
                {selected?.Users?.Users_NameSurname || `Kullanıcı #${selected?.Users_ID || "-"}`}
                {selected?.Users?.EMail ? ` (${selected.Users.EMail})` : ""}
              </p>
              <p className="mb-1">
                <strong>Tip:</strong> {selected?.Contact_Type || "Mesaj"}
              </p>
              <p className="mb-3">
                <strong>Tarih:</strong>{" "}
                {selected?.Created_Datetime ? moment(selected.Created_Datetime).format("DD.MM.YYYY HH:mm") : "-"}
              </p>
              <hr />
              <p style={{ whiteSpace: "pre-wrap" }}>{selected?.Contents || "-"}</p>

              <div className="d-flex justify-content-end mt-3">
                <Button color="secondary" onClick={() => setViewModal(false)}>Kapat</Button>
              </div>
            </ModalBody>
          </Modal>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(Messages);
